import { useQuery } from "@tanstack/react-query";
import { ApiError, ApiServiceError } from "libs/api";
import { QueryOptions } from "libs/reactQuery";

import { AuditLogResponse } from "../../auditLog.types";
import { requestGetAuditLogById } from "./getAuditLogById.request";

const useGetAuditLogById = (
  auditLogId: string,
  options?: QueryOptions<AuditLogResponse, ApiServiceError<ApiError>>
) => {
  const { data: auditLog, ...rest } = useQuery({
    queryKey: ["audit-logs", "admin", "one", auditLogId],
    queryFn: async () => await requestGetAuditLogById(auditLogId),
    enabled: !!auditLogId,
    cacheTime: 0,
    ...options
  });

  return { auditLog, ...rest };
};

export default useGetAuditLogById;
